import React from 'react';
import { hashHistory } from 'react-router';
import { logUserSearch } from '../actions/logActions';
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';

import '../index.css';
import ClickMe from 'material-ui/svg-icons/navigation/chevron-right';
import Up from 'material-ui/svg-icons/navigation/arrow-upward';
import {List, ListItem } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import { handleCategorySelect } from '../actions/shopActions';



class CareTypeDrillDown extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            procedures: [],
            isFetching: false,
            selectedCategory: 0
        }
    }

    loadProcedures = (cptCategoryId) => {

        var self = this;

        let config = {
            method: 'get',
            url: `shop/category/${cptCategoryId}`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
    
            self.setState({ procedures: response.data, isFetching: false }, ()=>{window.scrollTo(0,0)});
        })
        .catch(function (error) {
            console.log(error);
            self.setState({ isFetching: false });
        });
    }

    selectCategory = (cptCategoryId) => {
        this.setState({ selectedCategory: cptCategoryId });
        this.loadProcedures(cptCategoryId);
    }
    
    clearCategory = () => {
        this.setState({ selectedCategory: 0 });
    }

    selectProcedure = (sctp, name) => {
        localStorage.setItem('term', name);
        this.props.logUserSearch(sctp, name);
        hashHistory.push(`search/${sctp}`);
    }

    render() {
    
        var self = this;
        
        var dasCategories = this.props.categories.map((category, index) => 
            <div key={index}>
                <ListItem primaryText={category.CategoryDescription} onClick={() => self.selectCategory(category.CPTCategoryID)} className="trueno"  rightIcon={<ClickMe />}></ListItem>
                {((index + 1) !== self.props.categories.length) && (
                <Divider />
            )}
            </div>
        );

        var dasProcedures = this.state.procedures.map((procedure, index) =>   
            <div key={index}>
                <ListItem primaryText={procedure.FriendlyDescription} onClick={() => self.selectProcedure(procedure.ShoppableCPTCodeID, procedure.FriendlyDescription)} className="trueno" ></ListItem>
                {((index + 1) !== self.state.procedures.length) && (
                <Divider />
            )}
            </div>
        );
            
        return (
             <div>
                {(this.state.isFetching) && (
                    <div style={{textAlign:'center'}}>
                        <br />
                        <br />
                        <CircularProgress /> 
                        <br />
                        <br />
                    </div>
                )}

                {(!this.state.isFetching) && (
                    <div>
                        {(this.state.selectedCategory === 0) && (
                            <List>
                                { dasCategories }
                            </List>
                        )}
                        
                        {(this.state.selectedCategory > 0) && (
                            <div>
                                <IconButton tooltip="Return" style={{float:'right', marginTop:-35}} onClick={this.clearCategory}>
                                    <Up />
                                </IconButton>
                                <List>
                                    { dasProcedures }
                                </List>
                                    
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
};

//export default CareTypeDrillDown;

const mapDispatchToProps = (dispatch) => {
    return {
      logUserSearch: (sctp, term) => {
          dispatch(logUserSearch(sctp, term));
      }
    }
  }
  
  
  const mapStateToProps = (state) => ({
      member: state.thisApp.auth.member
  })
  
  
  export default connect(
      mapStateToProps,
    mapDispatchToProps
  )(CareTypeDrillDown)
  
  


// WEBPACK FOOTER //
// ./src/Components/CareTypeDrillDown.js